import { useAutoDetectOnboardingComplete } from '@/features/setup/hooks/use-auto-detect-onboarding-complete';
import { useDerivedStepTracker } from '@/features/setup/hooks/use-derived-step-tracker';
import { useOnboardingAccountSync } from '@/features/setup/hooks/use-onboarding-account-sync';
import { useSyncCostsConfigured } from '@/features/setup/hooks/use-sync-costs-configured';
import { useOnboardingBackendSync } from '@/features/setup/hooks/use-onboarding-backend-sync';
import { useSyncOnboardingState } from '@/features/setup/hooks/use-sync-onboarding-state';

export function OnboardingSyncProvider(): null {
  useOnboardingAccountSync();
  // Backend sync must run BEFORE auto-detect so that the hydrated state
  // (including dismissed) is in the store before auto-detect checks it.
  // Previously auto-detect could call dismiss() before hydration overwrote
  // the store with the backend's value, causing the dismiss PATCH to race
  // with hydration and sometimes revert.
  useOnboardingBackendSync();
  useAutoDetectOnboardingComplete();
  useSyncOnboardingState();
  useSyncCostsConfigured();
  // Track derived step completions and persist timestamps
  useDerivedStepTracker();
  return null;
}
